<div class="content" [ngClass]="{hidden:hidden$ | async}">
  <img class="bg" [src]="overlay$ | async" />

  <div class="frame" #frame>
    <div #html></div>
    <img [src]="overlay$ | async" />
  </div>
</div>
